import * as SunCalc from 'suncalc';

export interface SunTimes {
  sunrise: Date;
  sunset: Date;
  /** Civil twilight start → sunrise (~30 min before sunrise). */
  blueHourAM: { start: Date; end: Date };
  /** Sunset → civil twilight end (~30 min after sunset). */
  blueHourPM: { start: Date; end: Date };
  /** Sunrise → end of soft-light morning window (~1h after). */
  goldenHourAM: { start: Date; end: Date };
  /** Start of soft-light evening window → sunset (~1h before). */
  goldenHourPM: { start: Date; end: Date };
  /** Solar noon — useful as a reference. */
  solarNoon: Date;
}

export function getSunTimes(date: Date, lat: number, lng: number): SunTimes {
  const t = SunCalc.getTimes(date, lat, lng);
  // suncalc types these as `Date | null` (null only above the polar circle,
  // where the sun doesn't rise/set on some days) — none of this app's trips
  // go that far north, and formatTime/formatRange render '–' for non-Dates
  // if that assumption is ever wrong.
  return {
    sunrise: t.sunrise!,
    sunset: t.sunset!,
    blueHourAM: { start: t.dawn!, end: t.sunrise! },
    blueHourPM: { start: t.sunset!, end: t.dusk! },
    goldenHourAM: { start: t.sunrise!, end: t.goldenHourEnd! },
    goldenHourPM: { start: t.goldenHour!, end: t.sunset! },
    solarNoon: t.solarNoon,
  };
}

export function formatTime(d: Date): string {
  if (!(d instanceof Date) || isNaN(d.getTime())) return '–';
  return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
}

export function formatRange(start: Date, end: Date): string {
  return `${formatTime(start)}–${formatTime(end)}`;
}
